import { createSelector } from '@ngrx/store';
import { selectAuthState } from '../../core.state';
import { AuthState } from './auth.state';

export const selectAuth = createSelector(selectAuthState, (state: AuthState) => state);

export const selectIsAuthenticated = createSelector(selectAuthState, (state: AuthState) => state.isAuthenticated);
export const selectIsLoading = createSelector(selectAuthState, (state: AuthState) => state.isLoading);
export const selectAuthorities = createSelector(selectAuthState, (state: AuthState) => state.token?.authorities);
export const selectAuthentication = createSelector(
  selectIsAuthenticated,
  selectIsLoading,
  (isAuthenticated: boolean, isLoading: boolean) => {
    return {
      isAuthenticated,
      isLoading
    };
  }
);
export const selectToken = createSelector(selectAuthState, (state: AuthState) => state.token);
export const selectEmail = createSelector(selectAuthState, (state: AuthState) => state.token?.email);
